module.exports = __webpack_public_path__ + "img/qrcode.2b2f6ab0.svg";